export const messages = {
  en: {
    addOweFeeCallable: {
      title: 'Collection of Arrears',
      callableWay: 'Collection Method',
      selectCallableWay: 'Please select collection method',
      feeConfigs: 'Collection Fees',
      floor: 'Building',
      selectFloor: 'Please select building',
      timeRange: 'Time Range',
      selectTimeRange: 'Please select time range',
      startTime: 'Start Time',
      selectStartTime: 'Please select start time',
      endTime: 'End Time',
      selectEndTime: 'Please select end time',
      oweRooms: 'Arrears Rooms',
      noOweRooms: 'No arrears rooms',
      checkAll: 'Select All',
      ttsCall: 'Voice Collection',
      callableWayRequired: 'Collection method is required',
      roomsRequired: 'Please select arrears rooms',
      noOweRoomsSelected: 'No arrears rooms selected'
    }
  },
  zh: {
    addOweFeeCallable: {
      title: '催缴欠费',
      callableWay: '催缴方式',
      selectCallableWay: '请选择催缴方式',
      feeConfigs: '催缴费用',
      floor: '楼栋',
      selectFloor: '请选择楼栋',
      timeRange: '应收时间段',
      selectTimeRange: '请选择应收时间段',
      startTime: '开始时间',
      selectStartTime: '请选择开始时间',
      endTime: '结束时间',
      selectEndTime: '请选择结束时间',
      oweRooms: '欠费房屋',
      noOweRooms: '没有欠费房屋',
      checkAll: '全选',
      ttsCall: '语音催缴',
      callableWayRequired: '催缴方式不能为空',
      roomsRequired: '请选择欠费房屋',
      noOweRoomsSelected: '未选择欠费房屋'
    }
  }
}